import requester from '@/lib/axios';
import Activity from '@/models/Activity';
import { Nullable } from '@/models/Model';
import { ActivityQuestionOrder } from '@/data/services/activityServices';

export type ExamActivityDTO = {
  name: string;
  shuffleQuestions: boolean;
  timeLimit: Nullable<number>;
};

export const createExamActivity = async (
  examAreaId: number,
  body: ExamActivityDTO,
) => {
  const { data } = await requester().post<Activity>(
    `exam-areas/${examAreaId}/activities/`,
    body,
  );
  return data;
};

export const updateExamActivity = async (
  examAreaId: number,
  activityId: number,
  body: Partial<ExamActivityDTO>,
) => {
  const { data } = await requester().patch<Activity>(
    `exam-areas/${examAreaId}/activities/${activityId}/`,
    body,
  );
  return data;
};

export const deleteExamActivity = async (
  examAreaId: number,
  activityId: number,
) => {
  await requester().delete<void>(
    `exam-areas/${examAreaId}/activities/${activityId}/`,
  );
};

export const updateExamQuestionsOrder = async (
  examAreaId: number,
  body: ActivityQuestionOrder[],
) => {
  await requester().patch<void>(
    `exam-areas/${examAreaId}/activities/questions/order/`,
    body,
  );
};